import React from 'react'
import { FormResistance } from './FormResistance';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalResistance = (props) => {

    const {
        modal, tittle, closeDialogM, method,
        name,
        handleInputChange, loading,
        saveCreateDiscounts, saveUpdateDiscount
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialogM}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-thermometer-alt f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {tittle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-medium3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            onClick={saveCreateDiscounts}
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            onClick={saveUpdateDiscount}
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }


                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialogM}
                    >
                        Cancelar
                    </Button>

                </>
            }
        >

            {
                method === "create"
                    ? <FormResistance
                        button={"Crear"}
                        {...{ closeDialogM, loading, name, handleInputChange, methodAction: saveCreateDiscounts }}
                    />
                    : (method === "update")
                        ?
                        <FormResistance
                            button={"Actualizar"}
                            {...{ closeDialogM, loading, name, handleInputChange, methodAction: saveUpdateDiscount }} />
                        :
                        null
            }
        </Dialog>
    )
}
